import { render, staticRenderFns } from "./DinarOrder.vue?vue&type=template&id=5cf34398"
import script from "./DinarOrder.vue?vue&type=script&lang=js"
export * from "./DinarOrder.vue?vue&type=script&lang=js"
import style0 from "./DinarOrder.vue?vue&type=style&index=0&id=5cf34398&prod&lang=css"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports